// extracted by mini-css-extract-plugin
export default {"productGallery":"xJ-z","inQuickShop":"yJ-z"};